export interface Media {
    id: string;
    url: string;
    width: number;
    height: number;
    type: 'image' | 'video';
}

export enum ImportFormat {
    DO_NOT_IMPORT = 'do_not_import',
    IMPORT_DRAFT = 'import_draft',
    IMPORT_PUBLISH = 'import_publish',
}

export enum BusinessMemberStatus {
    APPROVED = 'approved',
    PENDING_APPROVAL = 'pending_approval',
}
